import { useCallback } from "react";

import { useGetRenewalWithOfferDocumentLazyQuery } from "@covertree/agent-portal-graphql";
import { Toast } from "@covertree/utils";
import { getErrorMessageFromApolloError } from "@utils/getErrorMessageFromApolloError";
import { ApolloError } from "@apollo/client";

export function useDownloadRenewalOfferDocument() {
  const [query, { loading }] = useGetRenewalWithOfferDocumentLazyQuery();

  const downloadRenewalOfferDocument = useCallback(
    async (renewalLocator: string) => {
      if (loading) {
        return;
      }

      try {
        const { data, error } = await query({
          variables: {
            renewalLocator,
          },
        });

        const renewalOfferUrl = data?.getRenewal?.offerDocument?.url;

        if (error) {
          throw new ApolloError(error);
        }

        if (!renewalOfferUrl) {
          throw new ApolloError({});
        }

        Toast.showSuccess("Renewal offer was downloaded successfully!");

        window.open(renewalOfferUrl, "_blank");
      } catch (error) {
        Toast.showError(
          getErrorMessageFromApolloError(error) ||
            "Failed to get renewal offer document data."
        );
      }
    },
    [loading]
  );

  return {
    downloadRenewalOfferDocument,
    loading,
  };
}
